import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/CampaignsChartForAllTime.graphql';
import { Query, QuerycampaignsChartForAllTimeArgs } from '../../__generated__/globalTypes';

export const useCampaignsChartForAllTimeQuery = (
  options?: QueryHookOptions<Query, QuerycampaignsChartForAllTimeArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerycampaignsChartForAllTimeArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useCampaignsChartForAllTimeLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerycampaignsChartForAllTimeArgs>
): QueryResult<Query, QuerycampaignsChartForAllTimeArgs> & {
  getCampaignsChartForAllTime: LazyQueryExecFunction<Query, QuerycampaignsChartForAllTimeArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getCampaignsChartForAllTime, result] = useLazyQuery<Query, QuerycampaignsChartForAllTimeArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getCampaignsChartForAllTime, ...result };
};

export const useCampaignsChartForAllTimePromiseQuery = () => {
  const client = useApolloClient();

  const getCampaignsChartForAllTime = useCallback(
    (options?: Omit<QueryOptions<QuerycampaignsChartForAllTimeArgs, Query>, 'query'>) =>
      client.query<Query, QuerycampaignsChartForAllTimeArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getCampaignsChartForAllTime };
};
// Suspense Query Hooks
export const useCampaignsChartForAllTimeSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerycampaignsChartForAllTimeArgs>
) => {
  const result = useSuspenseQuery<Query, QuerycampaignsChartForAllTimeArgs>(QUERY, {
    ...options
  });

  return result;
};
